/* ==========================================================================
   Google Consent Mode v2 & GDPR Cookie Management Component
   Supports: "Accept All", "Reject All", "Custom Settings", and Footer Recall
   100% Multi-Language i18n (CS, EN, DE, ES, PT, AR)
   ========================================================================== */

import { getLocale } from '../locales/i18n.js';

const cookieTranslations = {
  cs: {
    bannerTitle: '🍪 Nastavení ochrany soukromí & Cookies',
    bannerText: 'Používáme soubory cookie a analytické technologie k zajištění správného fungování webu, měření návštěvnosti a přizpůsobení obsahu. Můžete přijmout všechny cookies, odmítnout volitelné, nebo si upravit preference.',
    learnMore: 'Více o ochraně osobních údajů a cookies',
    acceptAll: 'Přijmout vše',
    rejectAll: 'Odmítnout vše',
    settingsBtn: 'Nastavení',
    modalTitle: 'Předvolby souborů cookie',
    modalDesc: 'Zvolte, které typy cookies nám povolíte zpracovávat. Nezbytné soubory cookie jsou nutné pro technické fungování stránek a nelze je vypnout.',
    necessaryTitle: 'Nezbytné technické cookies',
    necessaryBadge: 'Vždy aktivní',
    necessaryDesc: 'Tyto soubory jsou nezbytné pro základní bezpečnostní funkce webu, volbu jazyka a navigaci v systému.',
    analyticsTitle: 'Analytické cookies (Google Analytics)',
    analyticsDesc: 'Pomáhají nám porozumět návštěvnosti, oblíbenosti jednotlivých stránek a technickému výkonu webu bez ukládání citlivých osobních údajů.',
    marketingTitle: 'Marketingové a reklamní cookies (Google Ads)',
    marketingDesc: 'Používají se k měření efektivity reklamních kampaní a přesnějšímu zacílení bezpečnostních řešení JALUD.',
    savePreferences: 'Uložit předvolby',
    close: 'Zavřít'
  },
  en: {
    bannerTitle: '🍪 Privacy & Cookie Preferences',
    bannerText: 'We use cookies and analytics technologies to ensure proper website functionality, measure traffic, and optimize your experience. You can accept all, reject optional cookies, or customize your preferences.',
    learnMore: 'Learn more in our Cookie Policy',
    acceptAll: 'Accept All',
    rejectAll: 'Reject All',
    settingsBtn: 'Settings',
    modalTitle: 'Cookie Consent Preferences',
    modalDesc: 'Choose which cookie categories you allow us to use. Strictly necessary cookies are required for the technical operation of the website and cannot be disabled.',
    necessaryTitle: 'Strictly Necessary Cookies',
    necessaryBadge: 'Always Active',
    necessaryDesc: 'These cookies are essential for core security features, language selection, and responsive navigation.',
    analyticsTitle: 'Analytics Cookies (Google Analytics)',
    analyticsDesc: 'Help us understand website traffic, popular features, and overall technical performance without storing sensitive personal data.',
    marketingTitle: 'Marketing & Advertising Cookies (Google Ads)',
    marketingDesc: 'Used to measure advertising campaign effectiveness and relevant outreach for JALUD security solutions.',
    savePreferences: 'Save Preferences',
    close: 'Close'
  },
  de: {
    bannerTitle: '🍪 Datenschutz- & Cookie-Einstellungen',
    bannerText: 'Wir verwenden Cookies und Analysetechnologien, um die ordnungsgemäße Funktion der Website sicherzustellen, den Datenverkehr zu messen und Ihr Erlebnis zu optimieren.',
    learnMore: 'Mehr erfahren in unserer Cookie-Richtlinie',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Alle ablehnen',
    settingsBtn: 'Einstellungen',
    modalTitle: 'Cookie-Präferenzen anpassen',
    modalDesc: 'Wählen Sie aus, welche Cookie-Kategorien Sie zulassen möchten. Notwendige Cookies sind für den technischen Betrieb erforderlich.',
    necessaryTitle: 'Technisch notwendige Cookies',
    necessaryBadge: 'Immer aktiv',
    necessaryDesc: 'Erforderlich für Kernfunktionen, Sicherheit und Sprachauswahl.',
    analyticsTitle: 'Analyse-Cookies (Google Analytics)',
    analyticsDesc: 'Helfen uns zu verstehen, wie Besucher die Website nutzen, um Inhalte zu verbessern.',
    marketingTitle: 'Marketing- & Werbe-Cookies (Google Ads)',
    marketingDesc: 'Dienen der Messung von Werbekampagnen für JALUD-Sicherheitslösungen.',
    savePreferences: 'Einstellungen speichern',
    close: 'Schließen'
  },
  es: {
    bannerTitle: '🍪 Privacidad y Preferencias de Cookies',
    bannerText: 'Utilizamos cookies y tecnologías analíticas para garantizar el correcto funcionamiento del sitio web, medir el tráfico y optimizar su experiencia.',
    learnMore: 'Más información en nuestra Política de Cookies',
    acceptAll: 'Aceptar todo',
    rejectAll: 'Rechazar todo',
    settingsBtn: 'Configuración',
    modalTitle: 'Preferencias de Consentimiento de Cookies',
    modalDesc: 'Elija qué categorías de cookies nos permite utilizar. Las cookies necesarias no se pueden desactivar.',
    necessaryTitle: 'Cookies Técnicas Necesarias',
    necessaryBadge: 'Siempre activo',
    necessaryDesc: 'Esenciales para la seguridad del sitio, selección de idioma y navegación.',
    analyticsTitle: 'Cookies Analíticas (Google Analytics)',
    analyticsDesc: 'Nos ayudan a comprender el tráfico del sitio web y optimizar las páginas.',
    marketingTitle: 'Cookies de Marketing (Google Ads)',
    marketingDesc: 'Se utilizan para medir la eficacia de las campañas de soluciones de seguridad JALUD.',
    savePreferences: 'Guardar preferencias',
    close: 'Cerrar'
  },
  pt: {
    bannerTitle: '🍪 Privacidade e Preferências de Cookies',
    bannerText: 'Utilizamos cookies e tecnologias analíticas para garantir o correto funcionamento do site, medir o tráfego e otimizar a sua experiência.',
    learnMore: 'Saiba mais na nossa Política de Cookies',
    acceptAll: 'Aceitar tudo',
    rejectAll: 'Rejeitar tudo',
    settingsBtn: 'Configurações',
    modalTitle: 'Preferências de Consentimento de Cookies',
    modalDesc: 'Escolha quais categorias de cookies nos permite utilizar. Os cookies estritamente necessários não podem ser desativados.',
    necessaryTitle: 'Cookies Estritamente Necessários',
    necessaryBadge: 'Sempre ativo',
    necessaryDesc: 'Essenciais para funções básicas de segurança, idioma e navegação.',
    analyticsTitle: 'Cookies Analíticos (Google Analytics)',
    analyticsDesc: 'Ajudam-nos a compreender o tráfego do site e o desempenho técnico.',
    marketingTitle: 'Cookies de Marketing (Google Ads)',
    marketingDesc: 'Utilizados para medir a eficácia das campanhas das soluções de segurança JALUD.',
    savePreferences: 'Salvar preferências',
    close: 'Fechar'
  },
  ar: {
    bannerTitle: '🍪 الخصوصية وتفضيلات ملفات تعريف الارتباط',
    bannerText: 'نستخدم ملفات تعريف الارتباط وتقنيات التحليل لضمان الأداء السليم للموقع وقياس حركة المرور وتحسين تجربتك.',
    learnMore: 'تعرف على المزيد في سياسة ملفات تعريف الارتباط',
    acceptAll: 'قبول الكل',
    rejectAll: 'رفض الكل',
    settingsBtn: 'الإعدادات',
    modalTitle: 'تفضيلات الموافقة على ملفات تعريف الارتباط',
    modalDesc: 'اختر فئات ملفات تعريف الارتباط التي تسمح لنا باستخدامها. لا يمكن تعطيل ملفات تعريف الارتباط الضرورية.',
    necessaryTitle: 'ملفات تعريف الارتباط الضرورية',
    necessaryBadge: 'نشط دائمًا',
    necessaryDesc: 'ضرورية للأمان الأساسي وتحديد اللغة والتنقل.',
    analyticsTitle: 'ملفات تعريف الارتباط التحليلية (Google Analytics)',
    analyticsDesc: 'تساعدنا على فهم حركة زوار الموقع وتحسين الأداء التقني.',
    marketingTitle: 'ملفات تعريف الارتباط التسويقية (Google Ads)',
    marketingDesc: 'تُستخدم لقياس فعالية الحملات الإعلانية لحلول JALUD الأمنية.',
    savePreferences: 'حفظ التفضيلات',
    close: 'إغلاق'
  }
};

/**
 * Get current saved consent object or null
 */
export function getSavedConsent() {
  try {
    const raw = localStorage.getItem('sed_cookie_consent_v2');
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

/**
 * Update Google Consent Mode v2 State and notify dataLayer
 */
export function updateGoogleConsentMode(analyticsGranted, marketingGranted) {
  const consentObject = {
    analytics_storage: analyticsGranted ? 'granted' : 'denied',
    ad_storage: marketingGranted ? 'granted' : 'denied',
    ad_user_data: marketingGranted ? 'granted' : 'denied',
    ad_personalization: marketingGranted ? 'granted' : 'denied'
  };

  // 1. Send update command to gtag
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', consentObject);
  }

  // 2. Push consent_updated event to dataLayer for GTM triggers
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'consent_updated',
    consent_analytics: consentObject.analytics_storage,
    consent_marketing: consentObject.ad_storage,
    consent_ad_user_data: consentObject.ad_user_data,
    consent_ad_personalization: consentObject.ad_personalization
  });

  // 3. Persist user selection
  const storedData = {
    necessary: true,
    analytics: Boolean(analyticsGranted),
    marketing: Boolean(marketingGranted),
    timestamp: new Date().toISOString()
  };
  localStorage.setItem('sed_cookie_consent_v2', JSON.stringify(storedData));
}

/**
 * Open the detailed Cookie Settings Modal (can be triggered from Banner or Footer)
 */
export function openCookieSettings(onNavigate) {
  const lang = getLocale() || 'en';
  const t = cookieTranslations[lang] || cookieTranslations.en;
  const current = getSavedConsent() || { necessary: true, analytics: false, marketing: false };

  // Remove existing modal if any
  const existing = document.getElementById('sed-cookie-settings-modal');
  if (existing) existing.remove();

  const modalOverlay = document.createElement('div');
  modalOverlay.id = 'sed-cookie-settings-modal';
  modalOverlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(3, 14, 28, 0.85);
    backdrop-filter: blur(8px);
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    box-sizing: border-box;
  `;

  modalOverlay.innerHTML = `
    <div style="
      background: #07192f;
      border: 1px solid rgba(53, 168, 223, 0.3);
      box-shadow: 0 20px 50px rgba(0,0,0,0.6);
      border-radius: 14px;
      max-width: 620px;
      width: 100%;
      max-height: 90vh;
      display: flex;
      flex-direction: column;
      color: #ffffff;
      font-family: var(--font-body, system-ui, sans-serif);
      overflow: hidden;
    ">
      <!-- Modal Header -->
      <div style="padding: 1.5rem 1.75rem 1rem; border-bottom: 1px solid rgba(255,255,255,0.1); display: flex; justify-content: space-between; align-items: center;">
        <h3 style="margin: 0; font-size: 1.25rem; font-weight: 800; color: #ffffff; display: flex; align-items: center; gap: 8px;">
          <span>🍪</span> ${t.modalTitle}
        </h3>
        <button id="sed-cookie-modal-close-btn" style="background: none; border: none; color: rgba(255,255,255,0.7); font-size: 1.5rem; cursor: pointer; line-height: 1; padding: 0.25rem;">&times;</button>
      </div>

      <!-- Modal Body -->
      <div style="padding: 1.5rem 1.75rem; overflow-y: auto; flex: 1; display: flex; flex-direction: column; gap: 1.25rem;">
        <p style="margin: 0; font-size: 0.88rem; line-height: 1.6; color: rgba(255,255,255,0.85);">
          ${t.modalDesc}
        </p>

        <!-- Category 1: Strictly Necessary -->
        <div style="background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 1rem 1.25rem;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.4rem;">
            <div style="font-weight: 700; font-size: 0.95rem; color: #ffffff;">${t.necessaryTitle}</div>
            <span style="background: rgba(53, 168, 223, 0.2); color: #35a8df; font-size: 0.72rem; font-weight: 800; padding: 0.2rem 0.6rem; border-radius: 4px;">${t.necessaryBadge}</span>
          </div>
          <p style="margin: 0; font-size: 0.82rem; line-height: 1.5; color: rgba(255,255,255,0.65);">${t.necessaryDesc}</p>
        </div>

        <!-- Category 2: Analytics -->
        <div style="background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 1rem 1.25rem;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.4rem;">
            <label for="sed-cookie-toggle-analytics" style="font-weight: 700; font-size: 0.95rem; color: #ffffff; cursor: pointer; display: flex; align-items: center; gap: 8px;">
              ${t.analyticsTitle}
            </label>
            <input type="checkbox" id="sed-cookie-toggle-analytics" ${current.analytics ? 'checked' : ''} style="width: 18px; height: 18px; cursor: pointer; accent-color: #35a8df;" />
          </div>
          <p style="margin: 0; font-size: 0.82rem; line-height: 1.5; color: rgba(255,255,255,0.65);">${t.analyticsDesc}</p>
        </div>

        <!-- Category 3: Marketing & Ads -->
        <div style="background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 1rem 1.25rem;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.4rem;">
            <label for="sed-cookie-toggle-marketing" style="font-weight: 700; font-size: 0.95rem; color: #ffffff; cursor: pointer; display: flex; align-items: center; gap: 8px;">
              ${t.marketingTitle}
            </label>
            <input type="checkbox" id="sed-cookie-toggle-marketing" ${current.marketing ? 'checked' : ''} style="width: 18px; height: 18px; cursor: pointer; accent-color: #35a8df;" />
          </div>
          <p style="margin: 0; font-size: 0.82rem; line-height: 1.5; color: rgba(255,255,255,0.65);">${t.marketingDesc}</p>
        </div>

        <div>
          <a href="#cookie-policy" id="sed-cookie-policy-link" style="color: #35a8df; font-size: 0.82rem; text-decoration: underline;">${t.learnMore} →</a>
        </div>
      </div>

      <!-- Modal Footer Action Buttons -->
      <div style="padding: 1.25rem 1.75rem; border-top: 1px solid rgba(255,255,255,0.1); display: flex; gap: 0.75rem; justify-content: flex-end; flex-wrap: wrap; background: rgba(0,0,0,0.2);">
        <button id="sed-cookie-modal-reject" class="sed-btn sed-cookie-btn-reject" style="font-size: 0.85rem; padding: 0.55rem 1.1rem; background-color: transparent !important; color: #ffffff !important; border: 1.5px solid rgba(255,255,255,0.45) !important;">${t.rejectAll}</button>
        <button id="sed-cookie-modal-save" class="sed-btn sed-cookie-btn-settings" style="font-size: 0.85rem; padding: 0.55rem 1.2rem; background-color: rgba(53, 168, 223, 0.15) !important; color: #35a8df !important; border: 1.5px solid #35a8df !important; font-weight: 700 !important;">${t.savePreferences}</button>
        <button id="sed-cookie-modal-accept-all" class="sed-btn sed-cookie-btn-accept" style="font-size: 0.85rem; padding: 0.55rem 1.2rem; background-color: #10b981 !important; border: 1.5px solid #10b981 !important; color: #ffffff !important; font-weight: 700 !important;">${t.acceptAll}</button>
      </div>
    </div>
  `;

  document.body.appendChild(modalOverlay);

  // Event Listeners for Modal
  const closeModal = () => {
    modalOverlay.remove();
    // Hide bottom banner too if present
    const banner = document.getElementById('sed-cookie-banner-root');
    if (banner) banner.remove();
  };

  document.getElementById('sed-cookie-modal-close-btn').addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
  });

  document.getElementById('sed-cookie-modal-reject').addEventListener('click', () => {
    updateGoogleConsentMode(false, false);
    closeModal();
  });

  document.getElementById('sed-cookie-modal-save').addEventListener('click', () => {
    const analytics = document.getElementById('sed-cookie-toggle-analytics').checked;
    const marketing = document.getElementById('sed-cookie-toggle-marketing').checked;
    updateGoogleConsentMode(analytics, marketing);
    closeModal();
  });

  document.getElementById('sed-cookie-modal-accept-all').addEventListener('click', () => {
    updateGoogleConsentMode(true, true);
    closeModal();
  });

  const policyLink = document.getElementById('sed-cookie-policy-link');
  if (policyLink) {
    policyLink.addEventListener('click', (e) => {
      e.preventDefault();
      closeModal();
      if (typeof onNavigate === 'function') {
        onNavigate('cookie-policy');
      } else {
        window.location.hash = 'cookie-policy';
      }
    });
  }
}

/**
 * Render the Global 3-Option GDPR / Google Consent Mode v2 Cookie Banner
 */
export function renderCookieBanner(onNavigate) {
  const existing = document.getElementById('sed-cookie-banner-root');
  if (existing) existing.remove();

  // If consent is already stored, do not display the initial banner
  if (getSavedConsent()) return;

  const lang = getLocale() || 'en';
  const t = cookieTranslations[lang] || cookieTranslations.en;

  const banner = document.createElement('div');
  banner.id = 'sed-cookie-banner-root';
  banner.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
    max-width: 1100px;
    margin: 0 auto;
    background: rgba(7, 25, 47, 0.95);
    border: 1px solid rgba(53, 168, 223, 0.35);
    border-radius: 12px;
    box-shadow: 0 16px 40px rgba(0,0,0,0.5);
    backdrop-filter: blur(12px);
    z-index: 99999;
    padding: 1.25rem 1.5rem;
    color: #ffffff;
    font-family: var(--font-body, system-ui, sans-serif);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    box-sizing: border-box;
    animation: sedFadeInUp 0.3s ease-out;
  `;

  banner.innerHTML = `
    <div style="display: flex; flex-direction: column; gap: 0.5rem;">
      <div style="font-weight: 800; font-size: 1.05rem; color: #ffffff; display: flex; align-items: center; gap: 8px;">
        ${t.bannerTitle}
      </div>
      <div style="font-size: 0.88rem; line-height: 1.55; color: rgba(255,255,255,0.85);">
        ${t.bannerText}
        <a href="#cookie-policy" id="sed-banner-policy-link" style="color: #35a8df; text-decoration: underline; margin-left: 6px; white-space: nowrap;">${t.learnMore}</a>
      </div>
    </div>

    <!-- 3 Action Choices: Reject All, Settings, Accept All -->
    <div style="display: flex; gap: 0.65rem; justify-content: flex-end; align-items: center; flex-wrap: wrap;">
      <button id="sed-cookie-btn-reject" class="sed-btn sed-cookie-btn-reject" style="font-size: 0.85rem; padding: 0.5rem 1.1rem; background-color: transparent !important; color: #ffffff !important; border: 1.5px solid rgba(255,255,255,0.45) !important;">${t.rejectAll}</button>
      <button id="sed-cookie-btn-settings" class="sed-btn sed-cookie-btn-settings" style="font-size: 0.85rem; padding: 0.5rem 1.1rem; background-color: transparent !important; color: #35a8df !important; border: 1.5px solid rgba(53, 168, 223, 0.7) !important; font-weight: 600;">⚙️ ${t.settingsBtn}</button>
      <button id="sed-cookie-btn-accept" class="sed-btn sed-cookie-btn-accept" style="font-size: 0.85rem; padding: 0.5rem 1.25rem; background-color: #35a8df !important; color: #ffffff !important; border: 1.5px solid #35a8df !important; font-weight: 700 !important;">${t.acceptAll}</button>
    </div>
  `;

  document.body.appendChild(banner);

  // Accept All Click
  document.getElementById('sed-cookie-btn-accept').addEventListener('click', () => {
    updateGoogleConsentMode(true, true);
    banner.remove();
  });

  // Reject All Click
  document.getElementById('sed-cookie-btn-reject').addEventListener('click', () => {
    updateGoogleConsentMode(false, false);
    banner.remove();
  });

  // Settings Click
  document.getElementById('sed-cookie-btn-settings').addEventListener('click', () => {
    openCookieSettings(onNavigate);
  });

  // Policy Link Click
  const policyLink = document.getElementById('sed-banner-policy-link');
  if (policyLink) {
    policyLink.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof onNavigate === 'function') {
        onNavigate('cookie-policy');
      } else {
        window.location.hash = 'cookie-policy';
      }
    });
  }
}
